import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { COOKIES } from 'utils/constants'
import {
  cleanString,
  getFilterSelected,
  setEventToLazyDispatch,
  onClientSide
} from 'utils/utils'
import { config } from 'config/config.js'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'
import { withCookieNotice } from '@/store/context/cookie-notice-context'

import './CarouselContainer.scss'

class CardUltimasBuscas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      marca2: null,
      marca3: null,
      modelo2: null,
      modelo3: null,
      hasLastSearchesVariant: null,
    }
  }

  componentDidMount() {
    const isLastSearchActive = onClientSide() &&
    window.localStorage.getItem(config.abTest.lastSearches.key) === 'true' || false

    if (isLastSearchActive) {
      this.setState({ hasLastSearchesVariant: isLastSearchActive });
    } else {
      this.setState({ hasLastSearchesVariant: null });
    }
  }

  renderOptionals() {
    let optArr = []
    if (this.props.source && typeof this.props.source === 'object') {
      let { source } = this.props
      if (source.marca2) {
        this.setState({ marca2: source.marca2 })
      }
      if (source.marca3) {
        this.setState({ marca3: source.marca3 })
      }
      if (source.modelo2) {
        this.setState({ modelo2: source.modelo2 })
      }
      if (source.modelo3) {
        this.setState({ modelo3: source.modelo3 })
      }
      source.marca1 && (delete source.marca1)
      source.modelo1 && (delete source.modelo1)
      source.versao1 && (delete source.versao1)
      source.marca2 && (delete source.marca2)
      source.modelo2 && (delete source.modelo2)
      source.versao2 && (delete source.versao2)
      source.marca3 && (delete source.marca3)
      source.modelo3 && (delete source.modelo3)
      source.versao3 && (delete source.versao3)
      source.tipoveiculo && (delete source.tipoveiculo)
      source = getFilterSelected(source)
      for (
        let i = 0;
        i <
        (source.length &&
          (this.props.maxOptionals || this.props.maxOptionals === 0
            ? this.props.maxOptionals
            : 3));
        i++
      ) {
        if (typeof source[i] === 'string') {
          optArr.push(
            <span
              key={`optCard${this.props.model ? this.props.model : ''}${i}`}
            >
              {cleanString(source[i], { capitalizeAll: 1 })}
            </span>
          )
        }
      }
      optArr = optArr || false
    }
    if (optArr.length) {
      return <div className="CardUltimasBuscas__optionals">{optArr}</div>
    }
    return (
      <div className="CardUltimasBuscas__optionals CardUltimasBuscas__optionals--empty">
        Utilize os filtros para melhorar sua busca
      </div>
    )
  }

  renderMake() {
    return (
      this.props.make + (this.state.hasLastSearchesVariant ? '' : + (this.state.marca2 ? `, ${this.state.marca2}` : '') + (this.state.marca3 ? `, ${this.state.marca3}` : ''))
    )
  }

  renderModel() {
    return (
      this.props.model + (this.state.hasLastSearchesVariant ? '' : + (this.state.modelo2 ? `, ${this.state.modelo2}` : '') + (this.state.modelo3 ? `, ${this.state.modelo3}` : ''))
    )
  }

  render() {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.TRACKING_FROM
    )

    let CustomTag = 'div'
    this.props.linkTo && (CustomTag = Link)
    if (this.props.make && this.props.model) {
      return (
        <CustomTag
          to={`/${this.props.linkTo}`}
          id={this.props.id ? this.props.id : undefined}
          className={`CardUltimasBuscas AbTestCard${
            this.props.smallText ? ' CardUltimasBuscas--smallText' : ''
          }`}
          onClick={() => {
            if (isCookieCategoryActive) {
              setEventToLazyDispatch('buscaRealizada')
            }
          }}
        >
          <h3 className="CardUltimasBuscas__make">
            <span>{this.renderMake()} </span>
            <strong className="CardUltimasBuscas__model">
              {this.renderModel()}
            </strong>
          </h3>
          {this.renderOptionals()}
        </CustomTag>
      )
    }
    return false
  }
}

export default withCookieNotice(CardUltimasBuscas)
